import { render } from "./optionLink.vue?vue&type=template&id=6e453987&scoped=true"
import script from "./optionLink.vue?vue&type=script&lang=js"
export * from "./optionLink.vue?vue&type=script&lang=js"

import "./optionLink.vue?vue&type=style&index=0&id=6e453987&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e453987"]])

export default __exports__